import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDaciaComponent } from './simple-icons-dacia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDaciaComponent ],
    exports:      [ SimpleIconsDaciaComponent ],
    bootstrap:    []
})
export class SimpleIconsDaciaModule {}
